<script lang="ts">
    export let emoji = ':telescope:';
    export let size = '32px';

    const trimmed = emoji.replace(/:/gm, '');
</script>

<em-emoji id={trimmed} {size} />
